import React, { useContext } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Loader, Error, PrivateRoute, PublicRoute, EffectContext } from 'commons-ui';

import { PAGE_NAMES } from 'constant';
import Dashboard from 'pages/dashboard';
import Settings from 'pages/settings';
import Admin from 'pages/admin';
import Login from 'pages/login/Login';
import Home from 'pages/home';
import settingsV2 from 'commons-ui/src/pages/settingsV2';

import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import Logout from 'pages/logout/Logout';
import AuthorizedRoute from './AuthorizedRoute';

const Routes: React.FC<{}> = () => {
	const { loader } = useContext(EffectContext);
	if (loader) {
		return <Loader />;
	}

	return (
		<Switch>
			<PublicRoute exact path='/' component={Login} />
			<PublicRoute path='/login' exact component={Login} />
			<PrivateRoute path='/home' component={Home} />
			<AuthorizedRoute configPageName={PAGE_NAMES.dashboard} path='/dashboard' component={Dashboard} />
			<AuthorizedRoute configPageName={PAGE_NAMES.gameAdmin} path='/gameAdmin' component={Admin} />
			<AuthorizedRoute configPageName={PAGE_NAMES.settings} path='/settings' component={Settings} />
			<AuthorizedRouteV2 configPageName={PAGE_NAMES.settingsV2} path='/settingsV2' component={settingsV2} />

			<Route path='/logout' exact component={Logout} />
			<Route path='/error' component={Error} />
			<Redirect
				to={{
					pathname: '/error',
					state: { statusCode: 404, errorMsg: 'Page not found' }
				}}
			/>
		</Switch>
	);
};

export default Routes;
